import React, { useCallback, useState } from 'react'
import message from 'antd/lib/message'
import { apiManager } from 'helpers'
import times from 'lodash/times'

import { CloseIcon, PrimaryButton } from 'components'
import Modal from 'components/AuthModal/components/Modal'
import Overlay from 'components/AuthModal/components/Overlay'
import { OVERLAY } from 'components/AuthModal/styles'
import ProfileLabel from 'components/Profile/ProfileLabel'
import ProfileSelect from 'components/Profile/ProfileSelect'

const hNums = times(10).map(value => ({
  label: value,
  value,
}))

const defaultInput = {
  hNum: '',
}

const UserUpdateModal = ({ show, onClose, user }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [input, setInput] = useState({
    ...defaultInput,
    hNum: user.hNum?.toString() || '',
  })

  const handleInputChange = useCallback(e => {
    const { name, value } = e.target

    setInput(prev => ({
      ...prev,
      [name]: value,
    }))
  }, [])

  const handleSubmit = useCallback(
    async e => {
      e.preventDefault()

      message.loading('submitting...', 0)
      setIsSubmitting(true)

      const showError = errorMessage => {
        message.destroy()
        message.error(errorMessage || 'Please try again')
      }

      try {
        await apiManager.adminUpdateUser({
          id: user.id,
          data: input,
        })
        message.destroy()
        message.success('User updated successfully', 2.5)
        onClose(true)
      } catch (error) {
        showError(error.message)
      } finally {
        setIsSubmitting(false)
      }
    },
    [user, input, onClose]
  )

  return (
    <Overlay show={show} className={OVERLAY} preventEscBackdropClose={true} onClose={onClose}>
      <Modal innerClassName="bg-white rounded-t-3xl overflow-y-scroll md:rounded-xl">
        <div className="relative w-full p-5 md:p-7 md:py-5 md:w-108">
          <button className="bg-transparent absolute top-3 right-4" onClick={onClose}>
            <CloseIcon className="w-3 h-3" />
          </button>
          <div className="text-center text-xl font-bold font-ownersWide mb-10 underline">
            Update User
          </div>
          <form onSubmit={handleSubmit}>
            <div className="text-center">
              <div>
                <ProfileLabel className="text-black font-semibold">hNum</ProfileLabel>
                <ProfileSelect
                  name="hNum"
                  showDefault={false}
                  options={hNums}
                  value={input.hNum}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="flex justify-center mt-14">
              <PrimaryButton
                disabled={!input.hNum}
                type="submit"
                loading={isSubmitting}
                className="text-base h-10"
              >
                Submit
              </PrimaryButton>
            </div>
          </form>
        </div>
      </Modal>
    </Overlay>
  )
}

export default UserUpdateModal
